import type from '../commons/prescriptionActionsStatus';

const DEFAULT_STATE = {
    prescription: [],
    symptomBased: [],
    error: null,
    requestState: false,
    status: null,
    prescriptionCreated: {},
    savedPrescription: []
};

export const prescriptionReducer = (state = DEFAULT_STATE, action) => {
    const actionType = action.type;
    let error = action.error;
    let requestState = action.requestState;
    let status = action.status;
    switch (actionType) {

        case type.GET_RECOMMENDED_PRESCRIPTION_REQUEST:
            return { ...state, requestState, status, prescription: [], };

        case type.GET_RECOMMENDED_PRESCRIPTION_SUCCESS:
            if (action.prescriptionType == "SYMPTOM_BASED") {
                return {
                    ...state,
                    symptomBased: action.result,
                    requestState,
                    status,
                };
            }
            else {
                return {
                    ...state,
                    prescription: action.result,
                    requestState,
                    status,
                };
            }


        case type.GET_RECOMMENDED_PRESCRIPTION_FAILURE:
            return { ...state, error, requestState, status };

        case type.CREATE_PRESCRIPTION_REQUEST:
            return { ...state, requestState, status };

        case type.CREATE_PRESCRIPTION_SUCCESS:
            return {
                ...state,
                prescriptionCreated: action.result,
                requestState,
                status,
            };

        case type.CREATE_PRESCRIPTION_FAILURE:
            return { ...state, error, requestState, status };

        case type.GET_PATIENT_PRESCRIPTION_REQUEST:
            return { ...state,savedPrescription: [], requestState, status };

        case type.GET_PATIENT_PRESCRIPTION_SUCCESS:
            return {
                ...state,
                savedPrescription: action.result,
                requestState,
                status,
            };

        case type.GET_PATIENT_PRESCRIPTION_FAILURE:
            return { ...state, error, requestState, status };

        default:
            return state;
    }
};
